<template>
	<div class="m-4 p-4">
		<p v-for="(p, index) in paragraph($t('disclaimer-text'))" v-html="p" :key="index"></p>
		<div class="callout callout-danger" v-if="!show_meeting">
			<h4>{{ $t('select-meeting') }}</h4>
			<button @click="$router.push({name: 'meetings'})" type="button" class="btn btn-secondary m-2">{{ $t('meetings') }}</button>
			<button @click="$router.push({name: 'members'})" type="button" class="btn btn-secondary m-2">{{ $t('search-members') }}</button>
		</div>
		<h2 v-if="committee" class="mb-4">{{ $t('meeting_title',{ committee: committee}) }} {{ meeting_date | moment($t('date-format')) }}</h2>
		<div class="row mt-4 mb-4">
			<div class="col-12 col-md-4">
			<label for="search-meetings">{{ $t('search-meetings-more') }}</label>
			<input id="search-meetings" type="text" class="form-control" :placeholder="$t('search-example')" v-model="search_meetings" ref="search_meetings">
			</div>
		</div>
		<div v-if="search_meetings">
			<h3>{{ $t('current-filters') }}</h3>
			<ul class="list-unstyled">
				<a v-if="search_meetings" class="m-2 cursor badge badge-secondary" @click="search_meetings = ''">{{ $t('containing') }} {{ search_meetings }}</a>
			</ul>	
		</div>

		<div v-if="motions.length">
			<ParsedMotions :suppress_context="true" :motions="motions" v-on:order="order"></ParsedMotions>
		</div>
</div>
</template>

<script>
import OpenData from '@/libraries/OpenData'
import ParsedMotions from '@/components/ParsedMotions'

export default {
	components: { ParsedMotions },
	data() {
		return {
			show_meeting: false,
			motions: [],
			column: 'motion_id',
			direction: 'ASC',
			search_meetings: '',
			committee: '',
			meeting_date: '',
		}
	},
	created() {
		if (this.$route.params.meeting_id) {
			this.show_meeting = true;
			this.get_items();
		}
	},
	watch: {
		parameters() {
			this.get_items();
		},
	},

	computed: {
		order_parameters() {
			return [{key: this.column, direction: this.direction}, { key: 'member_type', direction: 'DESC'}, { key: 'member', direction: 'ASC'}];
		},

		parameters() {
			let where_parameters = [[{column: 'meeting_id',type: '=',params: [this.$route.params.meeting_id]}]];
			if (this.search_meetings.length > 0) {
				where_parameters.push([{column: 'title', type: 'LIKE', params: [this.search_meetings]}]);
			}
			let order_parameters = this.order_parameters;
			let limit_parameters = { limit: 1000000 };
			return { where_parameters, order_parameters, limit_parameters };
		},
	},
	methods: {
		async get_items() {
			const params = this.parameters;
			const url = this.$API_URL;
			this.motions = await OpenData.getResults(url,params);
			if (this.motions.length) {
				this.meeting_date = this.motions[0].meeting_date;
				this.committee = this.motions[0].committee_name;
			}
		},

		order(column,direction) {
			this.column = column;
			this.direction = direction;
		},

		paragraph(text) {
			return text.split("\r\n");
		},
	},
}
</script>

